export class Conferenceroom {
  id: string
  name: string
  des: string
  seats: string
  projectorCheck: boolean
}